export type TableProps = {
  data?: OperatorsType[];
};

export type OperatorsType = {
  nom: string;
  cognom: string;
  concession: number | string;
};

type columnIDTypes = { [key: string]: { id: string; label: string } };

// @deprecated Use getOperatorsColumnNames instead
export const columnNames: columnIDTypes = {
  nom: {
    id: 'nom',
    label: 'Nom',
  },
  cognom: {
    id: 'cognom',
    label: 'Cognom',
  },
  concession: {
    id: 'concession',
    label: 'Con.',
  },
};

// Dynamic column names with translations
export const getOperatorsColumnNames = (t: any): columnIDTypes => ({
  nom: {
    id: 'nom',
    label: t('tables:headers.name'),
  },
  cognom: {
    id: 'cognom',
    label: t('tables:headers.surname'),
  },
  concession: {
    id: 'concession',
    label: t('tables:headers.concession'),
  },
});
